export default "__VITE_ASSET__avNAjjkm__"